var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BAlert',{attrs:{"show":"","variant":"danger"}},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v(" error_outline ")]),_vm._v(" "+_vm._s(_vm.$t('autoAccess.access.dataSources.errorMessages.invalidJSONL'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }